import React from 'react'
import tw, { styled } from 'twin.macro'
import { motion } from 'framer-motion'
import { LevelEnum } from '@/types/nftAttribute'

const WrapperLeft = styled.div`
  background-image: url('/static/images/indexPage/03_step03/step03_img_line_left_normal.png');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: bottom right;
  width: 35.83vw;
  /* max-width: 668px; */
`

const Genesis = styled.div`
  ${tw`font-secondary font-semibold text-sm text-white mb-4`}
`

const Amount = styled.span`
  ${tw`font-secondary font-semibold text-xl`}
  color: #36fad7;
  display: inline-block;
  margin: 0 5px;
`

const DescInfo = styled.div`
  ${tw`font-primary text-xs mb-4`}
  color: #b5b5b5;
`

const Left: React.FC = () => {
  return (
    <WrapperLeft>
      <Genesis>
        Collection of <Amount>8,888</Amount> Genesis Shell NFT <br />
        Born out of Chaos and War
      </Genesis>
      <DescInfo>
        The SHELL is the flesh of the survivors in the PhalaWorld, it is the
        only abode of the SPIRIT.... Link Spirit to Shell to Enter PhalaWorld
      </DescInfo>
    </WrapperLeft>
  )
}

const Wrapper = styled.div`
  background-image: url('/static/images/indexPage/03_step03/step03_img_line_right_normal.png');
  background-repeat: no-repeat;
  background-size: contain;
  background-position: bottom right;
  width: 41.61vw;
  /* max-width: 798px; */
  position: relative;
`

const SquareBox = tw.div`flex items-center mb-4`

const Square = styled.span`
  ${tw`h-4 w-4`}
  display: inline-block;
  background: #36fad7;
`

const SquareText = styled.span`
  ${tw`font-secondary font-semibold text-base`}
  color: #ffffff;
  display: inline-block;
  margin-left: 0.78vw;
`

const Desc = tw.p`font-primary text-xs mb-4 text-white`

const Right: React.FC = () => {
  return (
    <Wrapper>
      <SquareBox>
        <Square />
        <SquareText>4 Species, 5 Careers</SquareText>
      </SquareBox>

      <Desc>
        {`${LevelEnum.Legendary} & ${LevelEnum.Magic} Shell NFT Public Sale Starts coming soon`}
      </Desc>
      <Desc>
        {`${LevelEnum.Common} Shell NFT Advanced Payment Starts coming soon`}
      </Desc>
    </Wrapper>
  )
}

export default function TopInfo() {
  return (
    <motion.div
      tw="flex flex-row justify-center gap-[4.32vw]"
      initial={{opacity: 0}}
      animate={{opacity: 1}}
      exit={{opacity: 0}}
      transition={{duration: 0.7, ease: 'easeInOut'}}
    >
      <Left />
      <Right />
    </motion.div>
  )
}
